import { createRoot } from "@wordpress/element";
import App from "./components/App";

import "@/utils/i18n";

document.querySelectorAll(".wp-block-tiles-tiles").forEach((el) => {
	const root = el.querySelector(".tiles__app");
	if (root) {
		createRoot(root).render(<App />);
	}
});
